export { default } from './JoshMascot';
